import Home from './Home';

export default Home;



// WEBPACK FOOTER //
// ./src/views/pages/Home/index.js